<template>
  <div id="container" data-ui-page="notfound">
    <div id="content" class="content">
      <div class="content-wrap">
        <div class="section">
          <div class="comp">
            <div class="error-box">
              <img
                src="@/resources/img/error/error_404.png"
                alt="잘못된 페이지"
                class="error-img"
              />
              <p class="error-tit">요청하신 페이지를 찾을 수 없습니다.</p>
              <p class="error-txt">
                입력하신 페이지 주소(URL)를 다시 확인해주세요.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { UI } from "@/resources/js/ui.common";

export default {
  mounted: function () {
    UI.init(this);
  },
};
</script>
